<div class="spinner">
    <mat-spinner></mat-spinner>
    <h1>Cargando...</h1>
</div>